var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProhibit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM13.5 8C13.5013 9.28596 13.0497 10.5313 12.2244 11.5175L4.4825 3.775C5.28563 3.10686 6.26243 2.68128 7.29861 2.54805C8.33479 2.41482 9.38749 2.57946 10.3335 3.0227C11.2795 3.46595 12.0797 4.16946 12.6405 5.05091C13.2013 5.93236 13.4994 6.95529 13.5 8ZM2.5 8C2.49872 6.71404 2.95035 5.46871 3.77563 4.4825L11.5175 12.225C10.7144 12.8931 9.73757 13.3187 8.70139 13.452C7.66521 13.5852 6.61252 13.4205 5.6665 12.9773C4.72048 12.5341 3.92026 11.8305 3.3595 10.9491C2.79873 10.0676 2.5006 9.04471 2.5 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibit);
export default __webpack_public_path__ + "static/media/Prohibit.404ed1cec455cb526c1bde1227101540.svg";
export { ForwardRef as ReactComponent };